import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store';
import mixpanel from 'mixpanel-browser';
import { logoutAdmin } from '../../../redux/slices/AuthorizationSlice';
import { UserMenuProps } from '../types';
import routes from '../../../constants/routes';
import { clearProfileState } from '../../../redux/slices/ProfileSlice';
import { useNavigate } from 'react-router-dom';
import { clearPaymentUserState } from '../../../redux/slices/PaymentUserSlice';
import { removeNativeUserFlag } from '../../Login/utils/LoginAuthGuard';

const UserMenu = ({ anchorEl, onClose, signOutLabel }: UserMenuProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const handleLogout = async () => {
    mixpanel.reset();
    dispatch(logoutAdmin());
    dispatch(clearProfileState());
    dispatch(clearPaymentUserState());
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('admin_email');
    removeNativeUserFlag();
    navigate(routes.ADMIN_LOGIN);
  };
  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      <MenuItem onClick={handleLogout}>{signOutLabel}</MenuItem>
    </Menu>
  );
};

export default UserMenu;
